import React from 'react';

const Default = () => {
    return <div>Default</div>;
};

export default Default;
